// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/tabs/style/index.less
// module id = 1073
// module chunks = 0